import { checkGet, checkPost } from './checkClient';

export type MarketplaceInterestStatus =
  | 'none'
  | 'open'
  | 'in_progress'
  | 'completed'
  | 'cancelled'
  | 'rejected';

export type MarketplaceInterestMode = 'primary' | 'backup';

export interface MarketplaceInterestResponse {
  plant_id: string;
  plant_name: string;
  status: MarketplaceInterestStatus;
  interest_mode?: MarketplaceInterestMode;
  support_request_id?: number;
  already_paid?: boolean;
  already_requested?: boolean;
  owner_email?: string;
  owner_phone?: string;
  message?: string;
}

export interface MarketplaceInterestReviewItem {
  request_id: number;
  plant_id: string;
  plant_name: string;
  requester_user_id: string;
  requester_email: string;
  status: Exclude<MarketplaceInterestStatus, 'none'>;
  interest_mode?: MarketplaceInterestMode;
  listing_status?: string;
  summary: string;
  status_note?: string;
  created_at: string;
  updated_at: string;
}

export async function getMarketplaceInterest(plantId: string): Promise<MarketplaceInterestResponse> {
  return checkGet<MarketplaceInterestResponse>(`/plants/${plantId}/intent`);
}

export async function expressMarketplaceInterest(plantId: string): Promise<MarketplaceInterestResponse> {
  return checkPost<MarketplaceInterestResponse>(`/plants/${plantId}/intent`, {});
}

export interface MyInterestItem {
  plant_id: string;
  plant_name: string;
  status: string;
  created_at: string;
}

export async function listMyMarketplaceInterests(): Promise<MyInterestItem[]> {
  return checkGet<MyInterestItem[]>('/marketplace/my-interests');
}

export async function withdrawMarketplaceInterest(requestId: number) {
  return checkPost(`/marketplace/interests/${requestId}/withdraw`, {});
}

export async function listMarketplaceInterestQueue(status = 'open') {
  return checkGet<{ interests?: MarketplaceInterestReviewItem[] }>(`/admin/marketplace/interests?status=${encodeURIComponent(status)}`);
}

export async function shareMarketplaceInterestContact(requestId: number, note?: string) {
  return checkPost(`/admin/marketplace/interests/${requestId}/share-contact`, note ? { note } : {});
}

export async function rejectMarketplaceInterest(requestId: number, note?: string) {
  return checkPost(`/admin/marketplace/interests/${requestId}/reject`, note ? { note } : {});
}

/** Batch procurement: sequentially express interest for multiple plant IDs (max concurrency 1). */
export async function expressMarketplaceInterestsBatch(
  plantIds: string[],
): Promise<MarketplaceInterestResponse[]> {
  const results: MarketplaceInterestResponse[] = [];
  for (const plantId of plantIds) {
    results.push(await expressMarketplaceInterest(plantId));
  }
  return results;
}
